import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectCampaignById } from '@user/store/campaigns/slice'

export const campaignValueFormatter = ({
  value,
}: GridValueFormatterParams): any =>
  typeof value === 'string'
    ? selectCampaignById(store.getState(), value)?.name ?? ''
    : ''
